module.exports = __webpack_public_path__ + "static/img/yingfu.c27066b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/case/yingfu.png
// module id = aoir
// module chunks = 34